export default __webpack_public_path__ + "static/media/clock.f682b6db.svg";